<template>
  <div class="topnavigation-container" v-if="navs.length">
    <div class="item" v-for="item in navs" :key="item.name">
      <div class="item-wrap" @click="handleNav(item)">
        <img class="item-icon" v-if="item.Languages.icon" :src="$utils.returnImgUrl(item.Languages.icon)" alt="" />
        <div class="item-name">{{ item.Languages.name }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { goJoinEvent } from "@/lobby_common/utils/utils.js";
export default {
  name: "topNavigation",
  data() {
    return {};
  },
  computed: {
    navs() {
      return (
        this.$store.getters.getPacketConfig?.topNavigationTemplate?.h5?.functions || []
      );
    },
  },
  methods: {
    handleNav(item) {
      goJoinEvent(item.jump);
    }
  },
};
</script>
<style lang="scss" scoped>
.topnavigation-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 45px;
	background-color: var(--background-1200);
	box-shadow: 0px 5px 20px 0px 
		rgba(4, 0, 0, 0.35);
  .item-wrap {
    padding: 0 20px;
    display: flex;
    align-items: center;
  }
  .item-name{
    margin-left: 10px;
    font-size: 14px;
    color: var(--font-color-100);
  }
  .item-icon{
    width: 22px;
    height: 22px;
  }
}
</style>